import { createClient } from '@supabase/supabase-js';

/** Real project credentials — used by DB client and Maps proxy (ignore .env.production placeholders) */
export const SUPABASE_URL = 'https://uhqaaexjvvmbpacuusac.supabase.co';
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVocWFhZXhqdnZtYnBhY3V1c2FjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEyMzAyNjQsImV4cCI6MjA2NjgwNjI2NH0.gg6xvKqPzEFDgIJmdVyIyPjBlx3EmKKPiip2IteYzvs';

const client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Debugging system removed - 406 errors have been resolved

export const supabase = client;
